class LocalStorageProvider {
    private static app = process.env.REACT_APP_NAME!.toLowerCase();
    static getUserInfo(): any | null {
        const data = localStorage.getItem(`${LocalStorageProvider.app}.user.info`);
        return data;
    }

    static setUserInfo(data: string): void {
        localStorage.setItem(`${LocalStorageProvider.app}.user.info`, data);
    }

    static persistSession(data: { token?: string, refreshToken?: string }): void {
        this.setUserInfo(JSON.stringify(data));
        if (data.token)
            this.setUserToken(data.token);
        if (data.refreshToken)
            this.setRefreshToken(data.refreshToken);
    }

    static removeUser(): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.user.info`);
        localStorage.removeItem(`${LocalStorageProvider.app}.user.token`);
        localStorage.removeItem(`${LocalStorageProvider.app}.user.refreshToken`);
    }
    static removeUserInfo(key: string, value: any): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.user.info`);
    }

    static getUserToken(): string {
        const token = localStorage.getItem(`${LocalStorageProvider.app}.user.token`);
        if(token == null)
            return `#`;
        return token;
    }

    static setUserToken(token: string): void {
        localStorage.setItem(`${LocalStorageProvider.app}.user.token`, token);
    }

    static getRefreshToken(): string {
        const token = localStorage.getItem(`${LocalStorageProvider.app}.user.refreshToken`);
        if (token)
            return token;
        try {
            const info = this.getUserInfo();
            if (info) {
                const parsed = typeof info === "string" ? JSON.parse(info) : info;
                return parsed?.refreshToken ?? "";
            }
        } catch {
            return "";
        }
        return "";
    }

    static setRefreshToken(token: string): void {
        localStorage.setItem(`${LocalStorageProvider.app}.user.refreshToken`, token);
    }

    static removeUserToken(): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.user.token`);
        localStorage.removeItem(`${LocalStorageProvider.app}.user.refreshToken`);
        localStorage.removeItem(`${LocalStorageProvider.app}.user.info`);
    }

    static getL10n(): 'fa' | 'en'{
        const l10n = localStorage.getItem(`${LocalStorageProvider.app}.local.l10n`);
        if (l10n === 'fa' || l10n === 'en') {
            return l10n;
        } else {
            return 'fa';
        }
    }

    static setL10n(l10n: 'fa' | 'en' | 'ar'): void {
        localStorage.setItem(`${LocalStorageProvider.app}.local.l10n`, l10n);
    }

    static setItem(key: string, value: any): void {
        localStorage.setItem(`${LocalStorageProvider.app}.local.custom.${key}`, value);
    }

    static getItem(key: string): any | null {
        return localStorage.getItem(`${LocalStorageProvider.app}.local.custom.${key}`);
    }

    static removeItem(key: string, value: any): void {
        localStorage.removeItem(`${LocalStorageProvider.app}.local.custom.${key}`);
    }
}


export default LocalStorageProvider
